export function date(date) {
    var originalDate = date
    date = date.split('-')
    date[0] = parseInt(date[0], 10)
    date[1] = parseInt(date[1], 10)
    date[2] = parseInt(date[2], 10)
    
    date = date.join('-')
    
    var d = new Date(originalDate)
        
    var months = {}
    months.en = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
    
    
    months.br = [
        "Janeiro",
        "Fevereino",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ]
    
    return {
        'day': (twoDigits = false) => {
            var day = d.getDate()
            day++
            if(twoDigits) {
                return (day < 10) ? '0'+day : day
            }
            return day
        },
        'month': (language = 'en') => {
            var month = d.getMonth()
            var monthName = months[language][month]
            return {
                'int': month,
                'str': monthName,
                'abbrev': monthName.slice(0,3),
            }
        },
        'br': originalDate.split('-').reverse().join('/')
    }
}

export function numberFormat (number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

export function dateHour(hour) {
   hour = hour.split(':') 
   return hour.map(i => i.length < 2 ? '0'+i : i).join(':')
}

export function timeToDate(unix_timestamp) {
    unix_timestamp = parseInt(unix_timestamp, 10)
    return new Date(unix_timestamp*1000)
}

export function toDate(date) {
    if(!date) return
    if(!date.indexOf) return

    
    if(date.indexOf('/') > -1)
    date = date.split('/').reverse()

    if(date.indexOf('-') > -1)
    date = date.split('-')
    
    return new Date(date[0], date[1]-1, date[2])
}

export function dateFormat(format, date) {
    date = toDate(date)
    if(!date) return
    let string = ''
    for (var i = 0; i < format.length; i++) {
        var key = format[i]

        switch (key) {
            case 'd':
                string += (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate()
                break
            case 'm':
                string += (date.getMonth()+1 < 10) ? `0${date.getMonth()+1}` : date.getMonth()+1
                break
            case 'y':
                string += date.getFullYear()
                break
            case 'h':
                string += (date.getHours() < 10) ? `0${date.getHours()}` : date.getHours()
                break
            case 'i':
                string += (date.getMinutes() < 10) ? `0${date.getMinutes()}` : date.getMinutes()
                break
            case 's':
                string += (date.getSeconds() < 10) ? `0${date.getSeconds()}` : date.getSeconds()
                break
            default:
                string += key
                break
        }
    }

    return string
}

export function replaceAccent(text) {       
    text = text.toLowerCase();                                                         
    text = text.replace(new RegExp('[ÁÀÂÃÅ]','gi'), 'a');
    text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
    text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
    text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
    text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
    text = text.replace(new RegExp('[Ç]','gi'), 'c');
    return text;                 
}


// WEBPACK FOOTER //
// ./src/libraries/Formatter.js